import { graphql } from "react-relay";

export const DISCOUNT_ACTION_FRAGMENT = graphql`
	fragment discountCodeCodesTableHeader_DiscountActionFragment on DiscountAction {
		...discountCodeCreateRandom_DiscountActionFragment
		...discountCodeCreateSingle_DiscountActionFragment
		...discountCodeDownloadCsvButton_DiscountActionFragment
	}
`;
